// Country names for ISO 3166-1 alpha-2 codes, from the runtime's own CLDR data
// rather than a list kept here: a hand list is one more thing to drift, and the
// codes this names are validated by the server before they reach the page.

// English, like every other string in the dashboard. A name in the browser's
// locale beside English labels would read as a mistake.
const REGION_NAMES = new Intl.DisplayNames(['en'], { type: 'region' });

/** The English name of a country code, or the code itself when the runtime
 *  has no name for it. */
export function countryName(code: string): string {
  return REGION_NAMES.of(code) ?? code;
}

// The user-assigned ranges exitcountry.Parse refuses (AA, QM-QZ, XA-XZ, ZZ).
function userAssigned(code: string): boolean {
  return code === 'AA' || code === 'ZZ' || (code[0] === 'Q' && code >= 'QM') || code[0] === 'X';
}

// Reserved codes CLDR names that are groupings, not a place a server sits in.
const GROUPINGS = new Set(['EU', 'EZ', 'UN']);

// A retired code (DD, SU, YU) is named after its successor, so it would list a
// second Germany. Locale canonicalization maps it to that successor.
function current(code: string): boolean {
  return new Intl.Locale(`und-${code}`).region === code;
}

let allCodes: string[] | undefined;

/** Every code the runtime names as a country, sorted by name, for a picker
 *  that must offer any country rather than the ones a VPN covers. Intl cannot
 *  enumerate regions, so this walks AA-ZZ and keeps the codes it can name. */
export function allCountryCodes(): readonly string[] {
  if (allCodes) return allCodes;
  const out: string[] = [];
  for (let a = 65; a <= 90; a++) {
    for (let b = 65; b <= 90; b++) {
      const code = String.fromCharCode(a, b);
      if (userAssigned(code) || GROUPINGS.has(code)) continue;
      if (countryName(code) !== code && current(code)) out.push(code);
    }
  }
  allCodes = out.sort((x, y) => countryName(x).localeCompare(countryName(y)));
  return allCodes;
}
